module.exports = __webpack_public_path__ + "img/email_white_24dp.d5510066.svg";